import script from "./PaymentsIndex.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentsIndex.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__